// Markets (language codes) where the MySAVICKI loyalty program is live.
// The program is currently PL-only; add a market code here once it is
// localized and ready to launch in that region (e.g. 'cs', 'sk', 'ro').
const LOYALTY_ENABLED_MARKETS = ['pl'];

// Whether the MySAVICKI loyalty program should be visible for the current store.
//
// Resolution order:
// 1. Backend override via store_config -> window.store_config_data.loyalty.enabled
//    (lets the program be toggled per-store from config without a frontend deploy).
// 2. Frontend market allowlist (LOYALTY_ENABLED_MARKETS).
export const isLoyaltyProgramEnabled = () => {
    const override = window.store_config_data?.loyalty?.enabled;
    if (typeof override === 'boolean') {
        return override;
    }

    return LOYALTY_ENABLED_MARKETS.includes(window.config?.language?.code);
};
